import React from 'react';
import PropTypes from 'prop-types';

const PromotionReviewStatusCorner = ({
  status,
  isFinal,
}) => (
  <div className={`promotion-review-status-corner ${status}${isFinal ? '-final' : ''}`}>
    <div className={`icon ${status}${isFinal ? '-final' : ''}`} />
  </div>
);

PromotionReviewStatusCorner.propTypes = {
  status: PropTypes.string.isRequired,
  isFinal: PropTypes.bool.isRequired,
};

export default PromotionReviewStatusCorner;
